var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHI1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.102.5l.692 1.865a2.965 2.965 0 002.067 1.846l1.931.479-1.865.692a2.965 2.965 0 00-1.846 2.067l-.478 1.931-.692-1.865a2.965 2.965 0 00-2.067-1.846l-1.931-.479 1.865-.692a2.966 2.966 0 001.846-2.067L19.102.5zm22.934 28.57l.568 1.531c.28.754.915 1.322 1.696 1.515l1.586.393-1.532.568a2.43 2.43 0 00-1.514 1.696l-.394 1.586-.568-1.532a2.432 2.432 0 00-1.696-1.514l-1.586-.393 1.532-.569a2.432 2.432 0 001.515-1.696l.393-1.585zM9.753 43.9l11.77-12.232a1.736 1.736 0 10-2.502-2.407L7.251 41.494a1.736 1.736 0 002.502 2.407zM35.211 9.384l5.906 5.905a2.777 2.777 0 010 3.928l-30.47 30.47a2.777 2.777 0 01-3.928 0L.813 43.782a2.777 2.777 0 010-3.927L31.285 9.384a2.776 2.776 0 013.926 0z",
    fill: "url(#h-i1_svg__paint0_linear_0_6398)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-i1_svg__paint0_linear_0_6398",
    x1: -5.279,
    y1: 9.59,
    x2: 7.874,
    y2: 56.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ac1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F85691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C2D"
  })))));
}
export default SvgHI1;